import faker from '@faker-js/faker';
import { MymePreview, MymeProgress } from '@myme/utils';
import { mockMymeStatus } from '../generalMocks';

export const mockMymePreview = (overrideMock?: Partial<MymePreview>): MymePreview => ({
  id: faker.datatype.uuid(),
  type: faker.random.arrayElement(['LOCATION_BASED', 'TIME_BASED', 'COURSE']),
  category: faker.random.arrayElement([
    'MENTAL_HEALTH',
    'BUSINESS',
    'SPORTS',
    'TOURISM',
    'HEALTH',
    'PERSONALITY',
    'FOOD',
    'LIFESTYLE'
  ]),
  name: faker.lorem.words(2),
  description: faker.lorem.paragraphs(3),
  author: {
    id: faker.datatype.uuid(),
    name: `${faker.name.firstName()} ${faker.name.lastName()}`
  },
  likes: faker.datatype.number(),
  rating: faker.datatype.number({ min: 1, max: 5, precision: 0.01 }),
  price: parseFloat(faker.commerce.price()),
  isHidden: faker.datatype.boolean(),
  previewImageFilePath: faker.image.nature(),
  status: mockMymeStatus(),
  ...overrideMock
});

const fakeProgressValue = faker.datatype.number({ min: 0, max: 100 });

export const mockMymeProgress = (overrideMock?: Partial<MymeProgress>): MymeProgress => ({
  value: fakeProgressValue,
  text: `${fakeProgressValue}%`,
  ...overrideMock
});
